module.exports = __webpack_public_path__ + "static/media/back-arrow.bddbb155.svg";